import {
  validateAccountNumber,
  validateAccountNumberUS,
  validateBankAccountColombia,
  validateBusinessName,
  validateCBU,
  validateCLABE,
  validateCUIT_CUIL,
  validateIBAN,
  validateNIF,
  validateNIT,
  validateRFC,
  validateRNC,
  validateRoutingNumber,
  validateRoutingNumberUS,
  validateSsnOrEin,
} from './validate';

export const accountValidationRules = {
  AR: (values, t) => {
    let errors = {};
    if (!values.accountNumber) {
      errors.accountNumber = t('stripe.AR.errors.accountId');
    }
    if (values.accountNumber && !validateCBU(values.accountNumber)) {
      errors.accountNumber = t('stripe.AR.errors.accountIdInvalid');
    }
    if (!values.accountNumberConfirm) {
      errors.accountNumberConfirm = t('stripe.AR.errors.accountIdConfirm');
    }
    if (values.accountNumber !== values.accountNumberConfirm) {
      errors.accountNumberConfirm = t('stripe.AR.errors.accountIdConfirmNotMatch');
    }
    if (!values.IdNumber) {
      errors.IdNumber = t('stripe.AR.errors.cuitCuil');
    }
    if (values.IdNumber && !validateCUIT_CUIL(values.IdNumber)) {
      errors.IdNumber = t('stripe.AR.errors.cuitCuilInvalid');
    }
    return errors;
  },

  DO: (values, t) => {
    let errors = {};
    if (!values.accountNumber) {
      errors.accountNumber = t('stripe.DO.errors.accountNumber');
    }
    if (values.accountNumber && !validateAccountNumber(values.accountNumber)) {
      errors.accountNumber = t('stripe.DO.errors.accountNumberInvalid');
    }
    if (!values.routingNumber) {
      errors.routingNumber = t('stripe.DO.errors.routingNumber');
    }
    if (values.routingNumber && !validateRoutingNumber(values.routingNumber)) {
      errors.routingNumber = t('stripe.DO.errors.routingNumberInvalid');
    }
    if (!values.IdNumber) {
      errors.IdNumber = t('stripe.DO.errors.personalTaxId');
    }
    if (values.IdNumber && !validateRNC(values.IdNumber)) {
      errors.IdNumber = t('stripe.DO.errors.personalTaxIdInvalid');
    }
    return errors;
  },

  MX: (values, t) => {
    let errors = {};
    if (!values.accountNumber) {
      errors.accountNumber = t('stripe.MX.errors.accountId');
    }
    if (values.accountNumber && !validateCLABE(values.accountNumber)) {
      errors.accountNumber = t('stripe.MX.errors.accountIdInvalid');
    }
    if (!values.accountNumberConfirm) {
      errors.accountNumberConfirm = t('stripe.MX.errors.accountIdConfirm');
    }
    if (values.accountNumber !== values.accountNumberConfirm) {
      errors.accountNumberConfirm = t('stripe.MX.errors.accountIdConfirmNotMatch');
    }
    if (!values.IdNumber) {
      errors.IdNumber = t('stripe.MX.errors.personalTaxId');
    }
    if (values.IdNumber && !validateRFC(values.IdNumber)) {
      errors.IdNumber = t('stripe.MX.errors.personalTaxIdInvalid');
    }
    return errors;
  },

  ES: (values, t) => {
    let errors = {};
    if (!values.accountNumber) {
      errors.accountNumber = t('stripe.ES.errors.accountId');
    }
    if (values.accountNumber && !validateIBAN(values.accountNumber)) {
      errors.accountNumber = t('stripe.ES.errors.accountIdInvalid');
    }
    if (!values.accountNumberConfirm) {
      errors.accountNumberConfirm = t('stripe.ES.errors.accountIdConfirm');
    }
    if (values.accountNumber !== values.accountNumberConfirm) {
      errors.accountNumberConfirm = t('stripe.ES.errors.accountIdConfirmNotMatch');
    }
    if (!values.IdNumber) {
      errors.IdNumber = t('stripe.ES.errors.personalTaxId');
    }
    if (values.IdNumber && !validateNIF(values.IdNumber)) {
      errors.IdNumber = t('stripe.ES.errors.personalTaxIdInvalid');
    }
    return errors;
  },
  CO: (values, t) => {
    let errors = {};
    if (!values.accountNumber) {
      errors.accountNumber = t('stripe.CO.errors.accountId');
    }
    if (!values.typeAccount) {
      errors.typeAccount = t('stripe.CO.errors.typeAccountRequired'); 
    }
    if (!values.routingNumber) {
      errors.routingNumber = t('stripe.DO.errors.routingNumber');
    }
    if (values.routingNumber && !validateRoutingNumber(values.routingNumber)) {
      errors.routingNumber = t('stripe.DO.errors.routingNumberInvalid');
    }

    if (values.accountNumber && !validateBankAccountColombia(values.accountNumber)) {
      errors.accountNumber = t('stripe.CO.errors.accountIdInvalid');
    }
    if (!values.accountNumberConfirm) {
      errors.accountNumberConfirm = t('stripe.CO.errors.accountIdConfirm');
    }
    if (values.accountNumber !== values.accountNumberConfirm) {
      errors.accountNumberConfirm = t('stripe.CO.errors.accountIdConfirmNotMatch');
    }
    if (!values.IdNumber) {
      errors.IdNumber = t('stripe.CO.errors.personalTaxId');
    }
    if (values.IdNumber && !validateNIT(values.IdNumber)) {
      errors.IdNumber = t('stripe.CO.errors.personalTaxIdInvalid');
    }
    return errors;
  },
  US: (values, t) => {
    let errors = {};
    if (!values.accountNumber) {
      errors.accountNumber = t('stripe.US.errors.accountId');
    }
    if (!values.routingNumber) {
      errors.routingNumber = t('stripe.US.errors.routingNumber');
    }
    if (values.routingNumber && !validateRoutingNumberUS(values.routingNumber)) {
      errors.routingNumber = t('stripe.US.errors.routingNumberInvalid');
    }

    if (values.accountNumber && !validateAccountNumberUS(values.accountNumber)) {
      errors.accountNumber = t('stripe.US.errors.accountIdInvalid');
    }
    if (!values.IdNumber) {
      errors.IdNumber = t('stripe.US.errors.ssnOrEin');
    }
    if (values.IdNumber && !validateSsnOrEin(values.IdNumber)) {
      errors.IdNumber = t('stripe.US.errors.ssnOrEinInvalid');
    }
   
    return errors;
  },
};
